import { APP_TOGGLE_LANGUAGE } from '../actions/app';

const initialState = {
  language: localStorage.getItem('lng') || 'fr'
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_TOGGLE_LANGUAGE:
      return {
        ...state,
        language: action.language
      };
    default:
      return state;
  }
};
